var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill-wrap"},[_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorOption},model:{value:(_vm._content_),callback:function ($$v) {_vm._content_=$$v},expression:"_content_"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }